<template>
    <div class="course">
        <div class="information">
            <div class="columns">
                <div class="column is-narrow is-hidden-touch">
                    <i class="fad fa-browsers has-text-primary fa-2x"></i>
                </div>
                <div class="column">
                    <div class="columns is-block-tablet is-flex-widescreen">
                        <div class="column">
                            <div class="has-text-weight-bold">
                                <i class="fad fa-browsers has-text-primary is-hidden-desktop mr-2"></i>
                                {{ course.title }}
                            </div>
                            <div class="meta">
                                {{ course.organization.title }}
                            </div>
                            <router-link to="/enrollments" v-if="course.enrolled">
                                <b-message type="is-success" class="mt-4"><i class="fas fa-check has-text-success mr-3"></i>You are already enrolled in this course.</b-message>
                            </router-link>

                            <b-collapse
                                class="card mt-4"
                                animation="slide"
                                :open="false"
                            >
                                <template #trigger="props">
                                    <div
                                        class="card-header"
                                        role="button"
                                        aria-controls="contentIdForA11y3"
                                        :aria-expanded="props.open">
                                        <p class="card-header-title">
                                            <i class="fas fa-magnifying-glass mr-2"></i>View Course Details
                                        </p>
                                        <a class="card-header-icon">
                                            <b-icon
                                                :icon="props.open ? 'caret-down' : 'caret-up'">
                                            </b-icon>
                                        </a>
                                    </div>
                                </template>

                                <div class="card-content content">
                                    <div class="mb-5" v-if="course.description">
                                        <div class="header"><i class="far fa-memo-circle-info fa-fw"></i>DESCRIPTION</div>
                                        <div class="pl-5 ml-1 pr-5" style="font-size: 0.95rem;">
                                            <div v-html="course.description"></div>
                                        </div>
                                    </div>
                                    <div class="mb-5 pt-3">
                                        <div class="header"><i class="far fa-diagram-cells fa-fw"></i>Outline</div>
                                        <div class="pl-5 ml-1 is-size-6">
                                            <ul>
                                                <li v-for="o in course.outline" :class="o.type">{{o.title}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>

                        </div>
                        <div class="column has-text-right is-narrow">
                            <b-button type="is-primary" size="" expanded @click="$emit('enroll', course)" class="mb-2" :disabled="course.enrolled || course.processing"><span v-if="!course.processing"><i class="fas fa-pencil mr-2"></i>Enroll</span><span v-else><i class="fas fa-spinner fa-spin mr-2"></i>Enrolling</span></b-button>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <div class="details">

        </div>

    </div>
</template>

<script>
    import {client as http} from "../http_client";

    export default {
        name: "CatalogCourse",
        props: ['course', 'details'],
        data: function() {
            return {
            };
        },
    };
</script>

<style lang="scss" scoped>
    .course {
        background-color: white;
        border-radius: 4px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.4);

        .information {
            padding: 1.5rem 1.5rem 1.5rem;
        }

        .meta {
            font-weight: normal;
            font-size: 0.8rem;
            color: #737881;
        }
        .header {
            font-weight: bold;
            font-size: 0.9rem;
            color: #336699;
            text-transform: uppercase;
            margin-bottom: 0.5rem;

            i {
                color: #5e5e5e;
                margin-right: 0.55rem;
            }
        }

        ul {
            border: 1px solid #eaeaea;
            border-radius: 5px;
            width: 80%;
            font-size: 0.95rem;
            margin-top: 1rem;

            li {
                border-bottom: 1px solid #eaeaea;
                padding: 0.2rem 0.8rem;

                &.HEADER {
                    background-color: #eaeaea;
                    font-weight: bold;
                }

                &:last-child {
                    border: none;
                }
            }

        }
    }
</style>
